export const toggleThemeStylesheet = (
  stylesheetMarker: string,
  disabled: boolean,
) => {
  for (const stylesheet of Array.from(document.styleSheets)) {
    try {
      if (stylesheet.cssRules[0]?.cssText.includes(stylesheetMarker)) {
        stylesheet.disabled = disabled;
      }
    } catch {
      // Cross-origin stylesheets (for example, Google Translate) do not expose
      // cssRules to page scripts. They are not application theme stylesheets.
    }
  }
};
